"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWarehouseActiveTime = exports.warehouseActiveTimeSchema = void 0;
const yup = require("yup");
const luxon_1 = require("luxon");
exports.warehouseActiveTimeSchema = yup.object().shape({
    from: yup.string().required(),
    to: yup
        .string()
        .required()
        .test("is-greater", "`to` should be greater than `from`", function (to) {
        const { from } = this.parent;
        if (!to || !from)
            return false;
        return (luxon_1.DateTime.fromFormat(from, "HH:mm") < luxon_1.DateTime.fromFormat(to, "HH:mm"));
    }),
    isoWeekday: yup.number().required(),
});
function isWarehouseActiveTime(obj) {
    return exports.warehouseActiveTimeSchema.isValidSync(obj);
}
exports.isWarehouseActiveTime = isWarehouseActiveTime;
//# sourceMappingURL=WarehouseActiveTime.js.map